const AIDesk = {
  "结束会话":"Tapusin ang Usapan",
  "转人工服务": "Ilipat sa Serbisyo ng Tao",
  "跳转":"Tumalon",
  "立即填写": "Punan Agad",
  "已提交": "Naisumite Na",
  "提交": "Isumite",
  "查看内容": "Tingnan ang Nilalaman",
  "请填写必填项": "Mangyaring punan ang mga kinakailangang field",
  "请输入内容":"Pakilagay ang nilalaman",
  "如果满意请给好评哦～":"Kung nasiyahan ka, mangyaring magbigay ng magandang pagsusuri~",
  "请对本次服务进行评价": "Mangyaring suriin ang serbisyong ito",
  "提交评价": "Ipasa ang pagsusuri",
  "并发限制": "Maraming tao ang naghahanap ng tulong ngayon, subukan muli mamaya",
  "分支选项异常": "Ang nilalaman ay abnormal, pakisuri ang configuration ng task flow",
  "服务评价": "Pagsusuri ng Serbisyo",
  "满意": "Nasisiyahan",
  "不满意": "Hindi nasisiyahan",
  "感谢您的反馈，我们会持续优化改进": "Salamat sa iyong feedback, patuloy naming pagbubutihin",
  "您遇到了哪方面的问题": "Anong problema ang iyong naranasan",
  "其他反馈内容": "Iba pang feedback",
  "取消": "Kanselahin",
  "答非所问": "Hindi nauugnay na sagot",
  "未匹配相关内容": "Walang katugmang nilalaman",
  "信息错误": "Maling impormasyon",
  "上下文理解错误": "Maling pag-unawa sa konteksto",
  "格式不规范": "Hindi tamang pormat",
  "内容不完整": "Hindi kumpletong nilalaman",
  "file 大小超过 100MB，无法发送": "Lampas sa 100MB ang file, hindi maipadala",
  "image 大小超过 20MB，无法发送": "Hindi maipadala ang larawan dahil lampas ito sa 20 MB",
  "video 大小超过 100MB，无法发送": "Hindi maipadala ang video dahil lampas ito sa 100 MB",
  "提交成功": "Matagumpay na naipasa",
  "userID 只能包含可打印 ASCII 字符": "Ang UserID ay dapat naglalaman lamang ng printable ASCII characters",
  "userID 不能包含'administrator'": "Ang UserID ay hindi dapat maglaman ng 'administrator'",
  "userID 长度不能超过45字节": "Ang haba ng UserID ay hindi dapat lumampas sa 45 bytes",
  "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "Pinahahalagahan namin ang iyong feedback. Mangyaring ibahagi ang anumang mga mungkahi upang matulungan kaming mapabuti.",
  "排队等待中": "Nasa pila na",
  "排队等待话术": "Paumanhin, puno na ang aming mga customer service. Mangyaring maghintay nang matiisin, tutulungan ka namin agad. Salamat sa iyong pag-unawa.",
  "当前前方排队人数": "Bilang ng mga tao sa unahan sa pila",
  "结束排队": "Umalis sa pila",
  "评价提交超过3分钟，无法更改。感谢您的反馈！": "Kapag lumipas na ang 3 minuto mula sa pagsusumite ng review, hindi na ito mababago.",
  "不能发送空白消息": "Hindi maaaring magpadala ng blangkong mensahe",
  "确认转人工": "Kumpirmahin ang paglipat sa ahente",
}
export default AIDesk;
